
function toString(v: any) {
  return Object.prototype.toString.call(v);
}

function isObject(v: any) {
  return toString(v) === '[object Object]';
}

function trim(v: string) {
  if (toString(v) !== '[object String]') {
    return v;
  }
  return v.replace(/^\s+|\s+$/g, '');
}


/**
  * 获取 http 协议
  * @returns {String}
  */
function getProtocol() {
  return window.location?.protocol || 'https:';
}

export function buildUrl(url: string | string[], params: null | Record<string, any>, useEncode: any) {
  let queryStr = '';

  if (!url) {
    throw new Error('[util.url.buildUrl]url is required');
  }
  if (!params || params === null) {
    return url;
  }
  queryStr = buildParams(params, useEncode);
  if (!queryStr?.length) {
    return url;
  }

  const protocol = getProtocol();
  if (url.indexOf('//') === 0) url = protocol + url;

  return [url, url.indexOf('?') > -1 ? '&' : '?', queryStr].join('');
}

function buildParams(params: { [x: string]: any; }, useEncode: any, strictMode?: boolean | undefined) {
  let v;
  let query;
  const r: any[] = [];
  Object.keys(params).forEach((k) => {
    v = params[k];
    query = buildParam(k, v, useEncode, strictMode);
    if (query !== null && query !== '') {
      r.push(query);
    }
  });
  return r.join('&');
}
function isValidKey(
  key: string | number | symbol,
  object: object
): key is keyof typeof object {
  return key in object;
}

function buildParam(k: string, v: string | object, useEncode: any, strictMode = true) {
  const type = typeof v;
  let i = 0;
  let len;
  let r: any[] = [];

  // 默认是严格模式，过滤空值
  if (v === '' && strictMode) {
    return '';
  }
  if (type === 'number' || type === 'string' || type === 'boolean') {
    return [k, useEncode ? encodeURIComponent(v as string) : v].join('=');
  }
  if (isObject(v)) {
    Object.keys(v).forEach((prop: string) => {
      if (isValidKey(prop, v as object)) {
        r.push(buildParam([k, '[', prop, ']'].join(''), v[prop], useEncode, strictMode));
      }
    });
  } else if (Array.isArray(v)) {
    for (len = v.length; i < len; i++) {
      r.push(buildParam([k, '[', i, ']'].join(''), v[i], useEncode, strictMode));
    }
  }
  // 过滤null, undefined, ''
  r = r.filter(item => item !== null && trim(item) !== '');
  return r.length ? r.join('&') : '';
}
